import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { ui } from "../data/ui";
import { Careers } from "../components/Careers";
import { Contact } from "../components/Contact";
import { Differentiators } from "../components/Differentiators";
import { FloatingCTA } from "../components/FloatingCTA";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Portfolio } from "../components/Portfolio";
import { Process } from "../components/Process";
import { SeoManager } from "../components/SeoManager";
import { Services } from "../components/Services";
import { Testimonials } from "../components/Testimonials";
import { TrustSignals } from "../components/TrustSignals";
export function Home() {
  const {
    t
  } = useLanguage();
  return <div className="min-h-screen w-full bg-ink text-white" data-id="element-413" data-mp="3kv0oj5mqugt0">
      <SeoManager data-id="element-414" data-mp="3ow42fml8e2rl" />
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-sm focus:bg-gold focus:px-4 focus:py-2 focus:font-semibold focus:text-ink" data-id="element-415" data-mp="3ovkmucj1zqgq">
        {t(ui.common.skip)}
      </a>
      <Header data-id="element-416" data-mp="2qyc14mchz4a9" />
      <main id="main" data-id="element-417" data-mp="2qxu43ni0gm1a">
        <Hero data-id="element-418" data-mp="2qx0tucjufeee" />
        <TrustSignals data-id="element-419" data-mp="2qwsjosf3un6w" />
        <Services data-id="element-420" data-mp="2mx0i4zo4phb1" />
        <Portfolio data-id="element-421" data-mp="2mxjp5lc8qlaa" />
        <Process data-id="element-422" data-mp="2mvyuzwtu94cy" />
        <Differentiators data-id="element-423" data-mp="2mwgvj5nja4qo" />
        <Testimonials data-id="element-424" data-mp="2mzcumxb4azgp" />
        <Careers data-id="element-425" data-mp="2hxnmbpfa4zwb" />
        <Contact data-id="element-426" data-mp="2hy75f9go1ubx" />
      </main>
      <Footer data-id="element-427" data-mp="2hz8e57a7m4qh" />
      <FloatingCTA data-id="element-428" data-mp="2i007ebgc3qdl" />
    </div>;
}